var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TjkTv() {
    return (_jsxs("div", __assign({ style: { textAlign: 'center', padding: '40px 20px' } }, { children: [_jsx("h3", __assign({ style: { marginBottom: 8 } }, { children: "TJK TV Yurt D\u0131\u015F\u0131 Canl\u0131 Yay\u0131n" }), void 0), _jsx("p", __assign({ style: { color: 'var(--color-text-medium)', marginBottom: 24, fontSize: 14 } }, { children: "TJK TV Yurt D\u0131\u015F\u0131 yay\u0131n\u0131n\u0131 YouTube \u00FCzerinden canl\u0131 izleyebilirsiniz." }), void 0), _jsx("a", __assign({ href: "https://www.youtube.com/live/ri4rR0H2i9c?si=tynYlCxBjcgho0m9", target: "_blank", rel: "noreferrer", className: "btn btn-danger", style: { fontSize: 15, padding: '10px 32px' } }, { children: "\u25B6 Canl\u0131 \u0130zle" }), void 0)] }), void 0));
}
